<template>
  <nc-login theme="light" />
</template>
